module.exports = __webpack_public_path__ + "img/tr.b2d99e45.jpg";